import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observer } from 'mobx-react';
import { connect } from "react-redux";
import { Dispatch } from 'redux';

import { ToastNotifications } from 'src/core/ui/toast';
import { FormatService } from 'src/core/services/format.service';
import { ObjectUtils } from 'src/core/utils/object';
import { AllotmentRangeDailyView } from 'src/app/products/allotment-range-daily/list/allotment-range-daily-list.view';
import { AllotmentRangeDailyListDataService } from 'src/app/products/allotment-range-daily/list/allotment-range-daily-list.data';
import { actionCreators } from "src/store/products/product-form-nav-actions";
import { observable } from 'mobx';

interface PropsFromState {
	rangeDailies: AllotmentRangeDailyItem[];
}

interface PropsFromDispatch {
	rangeDailiesLoaded: (allotment: AllotmentRangeItem, rangeDailies: AllotmentRangeDailyItem[]) => any;
}

interface Props extends ComponentViewProps<AllotmentRangeItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;

}

type ConnectedProps = Props & PropsFromDispatch & PropsFromState;

@observer
class AllotmentRangeDailyController extends React.Component<ConnectedProps, any> {
	@observable
	rangeDaily: AllotmentRangeDailyListDataService;

	@resolve
	protected toast: ToastNotifications;

	@resolve
	protected formatService: FormatService;

	@autobind
	protected async loadData(): Promise<void> {
		const { model, rangeDailies, setBusy, rangeDailiesLoaded, contextService } = this.props;

		this.rangeDaily = AllotmentRangeDailyListDataService.make(contextService, this.formatService);

		if (rangeDailies == null && model.id) {
			this.rangeDaily.addFilter('allotmentRangeId', 'eq', this.props.model.id);
			this.rangeDaily.addFilter('isDeleted', 'eq', false);
			this.rangeDaily.addSorting('day', 'asc', true);
			this.rangeDaily.pageSize = 100;
			try {
				setBusy(true);
				const items = await this.rangeDaily.load(query => query);
				rangeDailiesLoaded(model, items.slice());
			} catch (error) {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			} finally {
				setBusy(false);
			}
		} else {
			this.rangeDaily.items = rangeDailies;
		}
	}

	componentDidMount() {
		this.loadData();
	}

	componentWillReceiveProps(nextProps: Readonly<ConnectedProps>) {
		if (nextProps.rangeDailies != this.props.rangeDailies) {
			this.rangeDaily.items = nextProps.rangeDailies;
		}
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<AllotmentRangeDailyView
				model={this.rangeDaily}
				allotmentRange={this.props.model}
				mode={this.props.mode}
				setBusy={this.props.setBusy}
				onModeChanged={this.props.onModeChanged}
			/>
		);
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: Props
): PropsFromState => ({
	rangeDailies: (state.otherLoadedEntities.find(e => e.entity == props.model.entity) as AllotmentRangeItem).allotmentRangeDailies,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
	rangeDailiesLoaded: (
		allotment: AllotmentRangeItem,
		rangeDailies: AllotmentRangeDailyItem[],
	) => dispatch(actionCreators.productFormRelationshipLoaded(allotment, rangeDailies, "allotmentRangeDailies")),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(AllotmentRangeDailyController);
export { connected as AllotmentRangeDailyController };



// WEBPACK FOOTER //
// ./src/app/products/allotment-range-daily/list/allotment-range-daily-list.controller.tsx